import asyncComponent from '../../components/AsyncComponent';

const ClauseView = asyncComponent(() => import('../../containers/Clause/View'));

export default ClauseView;
